import { init, RematchDispatch, RematchRootState } from '@rematch/core'
import selectPlugin from '@rematch/select'
import models, { RootModel } from '@/models'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createStore = (options = {}) => {
  return init<RootModel>({
    name: 'Lakshmi',
    models,
    plugins: [selectPlugin()],
    ...options
  })
}
const store = createStore()

export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>

export const getStore = (): Store => {
  return store
}

export default store
const select = store.select
export { select }
